import React from 'react';
import { Reveal } from './Reveal';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  light?: boolean;
  align?: 'center' | 'left';
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  light = false,
  align = 'center'
}: SectionHeadingProps) {
  const alignCls = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  return <Reveal className={`flex flex-col ${alignCls} gap-4 max-w-3xl ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-192">
      {eyebrow && <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-medium uppercase tracking-[0.28em]" style={{
      color: 'var(--satinsheengold)'
    }} data-id="element-193">
          <span className="h-px w-8" style={{
        background: 'var(--satinsheengold)'
      }} data-id="element-194" />
          {eyebrow}
        </span>}
      <h2 className={`font-heading text-3xl sm:text-4xl md:text-5xl font-light leading-tight ${light ? 'text-white' : ''}`} style={!light ? {
      color: 'var(--ink)'
    } : undefined} data-id="element-195">
        {title}
      </h2>
      {subtitle && <p className={`text-base sm:text-lg leading-relaxed ${light ? 'text-white/75' : ''}`} style={!light ? {
      color: 'rgba(42,36,32,0.7)'
    } : undefined} data-id="element-196">
          {subtitle}
        </p>}
    </Reveal>;
}